import React, { FunctionComponent } from "react";
import styles from "./Entrance.module.scss";
import EntranceProps from "./EntranceProps.interface";

import Anchor from "components/Anchor/Anchor";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import Button from "components/Button/Button";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Paragraph from "components/Paragraph/Paragraph";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const Entrance: FunctionComponent<EntranceProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const imageAspectRatio = getImageAspectRatio(undefined, props.content.image?.umbracoWidth, props.content.image?.umbracoHeight);
    const headlineCaseClass = props.settings.headlineCase ? styles[`case_${props.settings.headlineCase}`] : undefined;

    const anchorLink = props.content.buttons && props.content.buttons.length > 0 ? props.content.buttons?.[0]?.content.link : undefined;

    return (
        <div className={combineClasses(styles.wrapper, ...wrapperClasses)} style={wrapperStyles}>
            <div className={styles.container}>
                <div className={styles.content}>
                    {/* Image */}
                    {props.content.image ? (
                        <ImageViewer className={styles.image} src={props.content.image.umbracoFile.src} extensionType="png" type="contain" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    ) : null}

                    {/* Tagline */}
                    {props.content.tagline ? (
                        <span className={styles.tagline}>{props.content.tagline}</span>
                    ) : null}

                    {/* Headline */}
                    {props.content.headline ? (
                        <DynamicHeading className={combineClasses(styles.headline, headlineCaseClass)} headlineSize={props.settings.headlineSize} headlineWeight={props.settings.headlineWeight}>{props.content.headline}</DynamicHeading>
                    ) : null}

                    {/* Text */}
                    {props.content.bodyText ? (
                        <Paragraph className={styles.text} innerHTML={props.content.bodyText} />
                    ) : null}

                    {/* Buttons */}
                    {props.content.buttons && props.content.buttons.length > 0 ? (
                        <div className={styles.buttons}>
                            {props.content.buttons.map((button) => (
                                <Button key={button.contentUdi} to={button.content.link} className={styles.button} variant={button.content.variant} {...button.content}>{button.content.label}</Button>
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <Anchor to={anchorLink} className={styles.background_link}>
                    <BackgroundMedia className={styles.background} {...props.settings.backgroundMedia[0]} />
                </Anchor>
            ) : null}
        </div>
    );
};

export default Entrance;